import React from 'react'
import { Parallax } from 'react-parallax'
import SanferRedLabel from '../../../baseComponents/SanferRedLabel'
import PageTitle from '../../../baseComponents/PageTitle'
import { Link } from 'react-router-dom'
import { getURLByRouteName } from '../../../utils/routes'

import arrow from '../../../assets/images/svg_icons/arrow.svg'
import titleLogo from '../../../assets/images/title-icons/Internet-Line.svg'

const Blog = props => {
  return <Parallax renderLayer={percent => {
    const { texts } = props
    const { blog } = props.data
      , posts = blog.posts instanceof Array
        ? blog.posts
        : []

    if (!posts.length) return null

    let postColumnOne = []
      , postColumnTwo = []
      , postColumnThree = []

    postColumnOne = posts.filter((_, i) => i > 0 && i < 3)
    postColumnTwo = posts.filter((_, i) => i > 2 && i < 6)
    postColumnThree = posts.length >= 7 ? posts[6] : null


    let featured = posts[0]

    return <div className='home__blog' style={{ opacity: percent }}>
      <SanferRedLabel />
      <PageTitle title={blog.title} label={blog.redLabel} logo={titleLogo} />
      <div className='home__blog-paragraphs gray-color' dangerouslySetInnerHTML={{ __html: blog.paragraphs }} />

      <div className='home__blog-featured'>
        <div className='home__blog-featured-cover' style={{ background: `url(${featured.cover})` }} >
          <div className='decorative top' />
          <div className='decorative bottom' />
        </div>
        <div className='home__blog-featured-content'>
          <SanferRedLabel text={texts.featured} />
          <div className='flex-row'>
            <div className='flex-row opacity-0'>
              <div className='gray-line' />
              <img src={titleLogo} alt='Titulo' />
            </div>
            <div className='home__blog-featured-block'>
              <h2>{featured.title}</h2>
              <p>{featured.extract}</p>
              <div className='gray-line' />
              <Link to={`${getURLByRouteName('blog')}/${featured.slug}`} className='white-color'>
                {texts.knowMore}
                <img className='arrow-left' src={arrow} alt='flecha' />
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className='home__blog-grid'>
        <div className='home__blog-column column-1'>
          {postColumnOne.map((post, index) => <BlogItem key={index} {...post} texts={texts} />)}
        </div>
        <div className='home__blog-column column-2'>
          {postColumnTwo.map((post, index) => <BlogItem key={index} {...post} texts={texts} />)}
        </div>
        <div className='home__blog-column column-3'>
          {
            !!postColumnThree &&
            <BlogItem {...postColumnThree} texts={texts} />
          }
        </div>
      </div>

      <div className="about-us__title-centered transition">
        <Link to={getURLByRouteName('post')} className="about-us__download-btn">
          {texts.blogBtn}
        </Link>
      </div>

    </div>
  }} />
}

export default Blog

const BlogItem = props => {
  const { texts } = props
  return <div className='home__blog-item'>
    <div className='home__blog-item-cover' style={{ background: `url(${props.cover})` }} />
    <div>
      <h2>{props.title}</h2>
      <Link to={`${getURLByRouteName('blog')}/${props.slug}`}>
        {texts.knowMore}
        <img className='arrow-left' src={arrow} alt='flecha' />
      </Link>
    </div>
  </div>
}